export const IMAGE_CAPTURE_ADD = 'IMAGE_CAPTURE_ADD';
export const LOAD_MEDIA = 'LOAD_MEDIA';
export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const TOGGLE_CAPTURED_IMAGES = 'TOGGLE_CAPTURED_IMAGES';
export const DELETE_MEDIA = 'DELETE_MEDIA';
